import React, { useCallback, useState } from 'react'
import cn from 'classnames'
import { NavLink } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import defaultLogo from '@src/images/header_logo.svg'
// import winterLogo from '@src/images/header_logo_new-year.svg'
import headerLine from '@src/images/header_line.svg'
import headerPhone from '@src/images/phone_header.svg'
import instagram from '@src/images/instagram_ico.svg'
import youtube from '@src/images/youtube_ico.svg'
import vk from '@src/images/vk_ico.svg'
import odnoklassniki from '@src/images/odnoklassniki_ico.svg'
import style from '@src/components/Header/Header.module.scss'
import userImg from '@src/images/user.svg'
import { Button } from '@src/components/Button/Button'
import { selectUserInfo, selectUserServices, selectUserUnreadMessages } from '@src/store/ducks/user/selectors'
import { ReactComponent as BurgerMenu } from '@src/images/logo_burger_menu.svg'
import { ReactComponent as ActiveBurgerMenu } from '@src/images/logo_active_burger_menu.svg'
import { Modal } from '@src/components/common/Modal/Modal'
import { CallBackForm } from '@src/components/CallBackForm/CallBackForm'
import { AppDispatch } from '@src/store/store'
import { selectContactsIsSuccessCallBack } from '@src/store/ducks/contacts/selectors'
import { setIsSuccessCallBack } from '@src/store/ducks/contacts/reducer'

export const Header = () => {
  const dispatch = useDispatch<AppDispatch>()
  const user = useSelector(selectUserInfo)
  const isSuccessCallBackMsg = useSelector(selectContactsIsSuccessCallBack)
  const [isAuth] = useState(false)
  const [burgerMenu, setBurgerMenu] = useState(false)
  const [isOpenCallBack, setIsOpenCallBack] = useState(false)
  const countUnreadMessages = useSelector(selectUserUnreadMessages)

  const { tariff } = useSelector(selectUserServices)

  const changeBurger = () => {
    setBurgerMenu(!burgerMenu)
    if (!burgerMenu) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'scroll'
    }
  }
  const formatNumber = (number: number) => {
    if (number >= 1000) {
      return `${(number / 1000).toFixed(1)}k`
    }
    return number
  }
  const handleCloseIsOpenCallBack = useCallback(() => {
    setIsOpenCallBack(false)
  }, [])

  const closeModal = useCallback(() => {
    dispatch(setIsSuccessCallBack(false))
    setIsOpenCallBack(false)
  }, [dispatch])

  // const currentDate = new Date()
  // const isWinter = (currentDate.getMonth() === 11 && currentDate.getDate() >= 1) // Декабрь
  //   || (currentDate.getMonth() === 0 || currentDate.getMonth() === 1) // Январь и Февраль
  //   || (currentDate.getMonth() === 2 && currentDate.getDate() < 1) // Март до 1 марта

  // const logo = isWinter ? winterLogo : defaultLogo
  const logo = defaultLogo

  return (
    <div className={cn(style.container, 'container')}>
      <div id={style.header}>
        <div className={style.left_header_part}>
          <div className={style.header_logo}>
            <a
              href={process.env.REACT_APP_SITE_URL}
            >
              <img
                src={logo}
                alt="logo"
                className="logo"
              />
            </a>
          </div>

        </div>
        {
          isAuth ? (
            <div className={style.right_header_part}>
              <ul className={style.nav}>
                <li>
                  <a href={process.env.REACT_APP_SITE_URL}>О компании</a>
                  {/* <a href="https://cosmos-telecom.by/about">О компании</a> */}
                </li>
                <li>
                  <a href={`${process.env.REACT_APP_SITE_URL}/about/news`}>Новости</a>
                </li>
                <li>
                  <a href="https://www.google.by/">Клиентам</a>
                </li>
                <li><a href={`${process.env.REACT_APP_SITE_URL}/tech-support`}>Помощь</a></li>
                <li>
                  <a href={`${process.env.REACT_APP_SITE_URL}/about/contacts`}>Контакты</a>
                </li>
              </ul>
              <div className={style.block_2}>
                <img
                  src={headerLine}
                  alt="header_line"
                  className={style.header_line}
                />

                <div className={style.phone_call}>
                  <a href="tel:134">
                    <img
                      src={headerPhone}
                      alt="phone"
                    />
                    <div className={style.phone}>134</div>
                  </a>
                </div>
              </div>
            </div>
          ) : (
            <div className={`${style.right_header_part} ${style.newPosition}`}>
              <ul className={style.nav}>
                <li><a href={`${process.env.REACT_APP_SITE_URL}/for-home/actions`}>Акции</a></li>
                <li><a href={`${process.env.REACT_APP_SITE_URL}/oplata-uslug`}>Оплата</a></li>
                <li>
                  <a href={`${process.env.REACT_APP_SITE_URL}/tech-support/pakety-i-kanaly/home-chanels`}>
                    Тарифные планы
                  </a>
                </li>
                <li>
                  <a href={`${process.env.REACT_APP_SITE_URL}/news/tehnicheskie-raboty`}>
                    Технические работы
                  </a>
                </li>
              </ul>
              <div className={style.block_2}>

                <div className={style.box}>
                  <Button
                    className={style.addCallBtn}
                    type="primary"
                    onClickFunc={() => setIsOpenCallBack(true)}
                  >
                    Заказать звонок
                  </Button>
                  {/* {activeModalSuccess && <Popup backCallSuccess newStyle={style.popUpSuccess} />} */}
                  <div className={style.phone}>
                    <div className={style.number}>
                      {' '}
                      <a href="tel:+375 (17) 289-29-29">+375 (17) 289-29-29</a>
                    </div>
                    <div className={style.description}>
                      Техподдержка с 9:00 до 23:00
                    </div>
                  </div>
                </div>

                <img
                  src={headerLine}
                  alt="header_line"
                  className={style.header_line}
                />

                <div className={style.phone_call}>
                  <a href="tel:134">
                    <img
                      src={headerPhone}
                      alt="phone"
                    />
                    <div className={style.phone}>134</div>
                  </a>
                </div>
              </div>
            </div>
          )
        }
      </div>
      <div id={style.mobile_header}>
        <div className={cn(style.container, 'container')}>
          <div className={style.header_logo}>
            <NavLink
              to="/"
            >
              <img
                src={logo}
                alt="logo"
                className="logo"
              />
            </NavLink>
          </div>
          <div className={style.right_part}>
            <div className={style.phone_call}>
              <a href="tel:134">
                <img
                  src={headerPhone}
                  alt="phone"
                />
                <div className={style.phone}>134</div>
              </a>
            </div>
            <div className={cn(style.burger_menu, burgerMenu && style.active)}>
              <div
                tabIndex={0}
                role="button"
                onKeyDown={changeBurger}
                onClick={changeBurger}
                id={style.not_active_burger}
                className={cn(burgerMenu && style.none)}
              >
                <BurgerMenu />
              </div>

              <div
                tabIndex={0}
                role="button"
                onKeyDown={changeBurger}
                onClick={changeBurger}
                id={style.active_burger}
                className={cn(burgerMenu && style.displayFlex)}
              >
                <ActiveBurgerMenu />
              </div>
            </div>
          </div>

          <div id={style.active_menu} className={cn(burgerMenu && style.displayBlock)}>
            <div className={cn(style.container, 'container')}>
              <div className={style.tabs_content}>
                <div id="m-tab-1" className={style.tabs_content__item}>
                  <div className={style.items_mob}>
                    <div className={style.item}>
                      <a href="/">
                        <img src={userImg} alt="logo user" />
                        <span>{user.username}</span>
                      </a>
                    </div>
                    <NavLink
                      activeClassName={style.activeMobileMenu}
                      onClick={changeBurger}
                      to="/my-profile"
                      className={style.item}
                    >
                      <div>Мой профиль</div>
                    </NavLink>
                    <NavLink
                      activeClassName={style.activeMobileMenu}
                      onClick={changeBurger}
                      to="/payments"
                      className={style.item}
                    >
                      <div>История платежей</div>
                    </NavLink>
                    <NavLink onClick={changeBurger} activeClassName={cn(style.activeMobileMenu)} to="/messages" className={cn(style.ind_item, style.ind_item_mgs, style.item)}>
                      <div>Сообщения</div>
                      {countUnreadMessages > 0 ? (
                        <i className={style.ind_item_mgs_icon}>
                          +
                          {formatNumber(countUnreadMessages)}
                        </i>
                      ) : null}
                    </NavLink>
                    {!!tariff.length && !user.isSubscriber && (
                      <NavLink
                        activeClassName={style.activeMobileMenu}
                        onClick={changeBurger}
                        to={`/additional-services/${tariff[0].serviceId}`}
                        className={style.item}
                      >
                        <div>Дополнительные услуги</div>
                      </NavLink>
                    )}
                  </div>
                  <ul>
                    <li><a href={`${process.env.REACT_APP_SITE_URL}/for-home/actions`}>Акции</a></li>
                    <li><a href={`${process.env.REACT_APP_SITE_URL}/oplata-uslug`}>Оплата</a></li>
                    <li>
                      <a href={`${process.env.REACT_APP_SITE_URL}/tech-support/pakety-i-kanaly/home-chanels`}>
                        Тарифные планы
                      </a>
                    </li>
                    <li>
                      <a href={`${process.env.REACT_APP_SITE_URL}/news/tehnicheskie-raboty`}>
                        Технические работы
                      </a>
                    </li>
                  </ul>
                  <div className={style.social_m}>
                    <div className={style.soc_text}>
                      Мы в социальных сетях
                    </div>
                    <div className={style.items_m_s}>
                      <a target="_blank" href="https://www.instagram.com/cosmostelecom.by/" rel="noreferrer">
                        <img src={instagram} alt="instagram" className={style.item} />
                      </a>
                      <a target="_blank" href="https://ok.ru/cosmostelecom" rel="noreferrer">
                        <img src={odnoklassniki} alt="odnoklassniki" className={style.item} />
                      </a>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/channel/UCIWmAmXL1xR08Bm3-wqNgIQ/feed"
                        rel="noreferrer"
                      >
                        <img src={youtube} alt="youtube" className={style.item} />
                      </a>
                      <a target="_blank" href="https://vk.com/cosmos_telecom" rel="noreferrer">
                        <img src={vk} alt="vk" className={cn(style.item, style.vk)} />
                      </a>
                    </div>
                  </div>
                  <Button
                    className={style.addCallBtn}
                    type="primary"
                    onClickFunc={() => setIsOpenCallBack(true)}
                  >
                    Заказать звонок
                  </Button>
                  <Modal styleModalWindow={style.callBack} isOpen={isOpenCallBack} close={handleCloseIsOpenCallBack}>
                    <CallBackForm />
                  </Modal>
                  <Modal styleModalWindow={style.callBackSuccess} isOpen={isSuccessCallBackMsg} close={closeModal}>
                    <>
                      <div className={style.text}>
                        Ваша заявка
                        {' '}
                        <span>успешно отправлена!</span>
                        {' '}
                      </div>
                      <p>
                        В ближайшее время с Вами свяжется наш специалист для уточнения необходимых деталей.
                      </p>
                    </>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
